export const cookieCopyEN = {
  banner: {
    title: 'Your privacy and our use of cookies',
    description:
  'TradeSagePro uses cookies and similar technologies to keep the platform secure, prevent fraud, and analyze traffic to improve our service.',
    privacyLinkLabel: 'Privacy Policy',
    buttons: {
      acceptAll: 'Accept All Cookies',
      reject: 'Reject Non‑Essential',
      manage: 'Manage Settings',
      savePreferences: 'Save Preferences',
    },
  },
  settings: {
  title: 'Cookie settings on TradeSagePro',
    categories: {
      necessary: {
        title: 'Strictly Necessary',
        description:
          'These cookies and similar technologies are critically important for the core functionality and security of the TradeSagePro platform. They enable essential features such as user authentication, secure session management, and fraud prevention. To protect your account, our system analyzes technical data, including your IP address and device information, to detect and prevent unauthorized access. For these reasons, these technologies cannot be disabled.',
      },
      analytics: {
        title: 'Analytics and quality improvements',
        description:
          'These cookies (e.g., Google Analytics) help us understand which features users value and how the platform is used. Without these insights, we cannot effectively optimize the service.',
      },
      marketing: {
        title: 'Marketing and personalization',
        description:
          'These cookies are used to measure the effectiveness of our campaigns and show the most relevant offers to you.',
      },
    },
    buttons: {
      cancel: 'Cancel',
      save: 'Save Preferences',
    },
  },
} as const;
